import customAxios from './axiosConfig'

const TemporaryFileService = {
  getById(id) {
    const api_url = window.Urls['temporaryfile-detail'](id)
    return customAxios.get(api_url)
  },
  list(filters) {
    const api_url = window.Urls['temporaryfile-list']()
    return customAxios.get(api_url, { params: filters })
  },
  loadNextPage(nextUrl) {
    return customAxios.get(nextUrl)
  },
  download(id) {
    const api_url = window.Urls['temporaryfile-download'](id)
    return customAxios.get(api_url)
  },
  regenerate(id) {
    const api_url = window.Urls['temporaryfile-regenerate'](id)
    return customAxios.post(api_url)
  }
}

export default TemporaryFileService
